import React from 'react';
import PropTypes from 'prop-types';
import Option from '../option';

const renderOptions = (options, onAnswer) => {
  return options.map(opt => {
    return <Option key={opt.tag} onAnswer={onAnswer} {...opt} />
  })
};

const Question = ({ question, onAnswer }) => {
  const { question: title, options } = question;
  return (
    <div>
      <h2 className="mw8 center dark-blue-gray f1-ns f2 fw9 tracked-tight mt0 mb3 lh-tight">{title}</h2>
      <div className="flex flex-row-ns flex-wrap flex-column justify-around-ns mt5-ns mt4 ">
      {options && renderOptions(options, onAnswer)}
      </div>
    </div>
  );
};

Question.propTypes = {
  id: PropTypes.number,
  question: PropTypes.object,
  onAnswer: PropTypes.func,
};

export default Question;



// WEBPACK FOOTER //
// ./src/components/question/Question.js